import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { contactsColorKeys } from './_colors'

const {
  ContactsDetailView: ContactsDetailViewColors,
  ContactItem: ContactItemColors,
} = contactsColorKeys.Contacts

const ContactItemParts = [
  'container',
  'dataContainer',
  'labelContainer',
  'labelText',
  'primaryBadge',
  'numberText',
  'hStack',
  'empty_container',
  'empty_icon',
  'empty_text',
] as const

const helpers = createMultiStyleConfigHelpers(ContactItemParts)

export const ContactItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingY: '1.25rem',
      borderBottom: '1px solid',
      borderColor: ContactsDetailViewColors.InnerContainer.BorderColor,
    },
    dataContainer: {
      flexDirection: 'column',
      gap: '0.25rem',
    },
    labelContainer: {
      alignItems: 'center',
      gap: '0.25rem',
    },
    labelText: {
      textStyle: textStyleKeys.Body1,
    },
    primaryBadge: {
      alignItems: 'center',
      height: '1.125rem',
      paddingX: '0.5rem',
      backgroundColor: ContactItemColors.Badge.BackgroundColor,
      color: ContactItemColors.Badge.FontColor,
      fontSize: '0.6875rem',
      fontWeight: '700',
      borderRadius: '0.25rem',
    },
    numberText: {
      textStyle: textStyleKeys.H6,
    },
    hStack: {
      gap: '0.25rem',
    },
    empty_container: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingY: '3.75rem',
      gap: '1.25rem',
      borderBottom: '1px solid',
      borderColor: ContactsDetailViewColors.InnerContainer.BorderColor,
    },
    empty_icon: {
      boxSize: '6.25rem',
      color: ContactItemColors.EmptyIcon.Color,
    },
    empty_text: {
      textStyle: textStyleKeys.H6,
      textAlign: 'center',
      color: ContactItemColors.EmptyText.FontColor,
    },
  },
})

export const useContactItemStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ContactItemParts>(
    getName({ ContactItemStyle }),
    props,
  )
}
